import React, { useState } from "react";
import { useLsp } from "../store/LspContext";
import { apiInitiateNach } from "../api/lspApi";

export default function InitiateNachPage() {
    const { state } = useLsp();
    const [mode, setMode] = useState("esign"); // esign | upi
    const [out, setOut] = useState("");
    const [loading, setLoading] = useState(false);

    const run = async () => {
        setLoading(true); setOut("");
        try {
            const body = mode === "upi"
                ? { account_type: "savings", is_setu: true }
                : { account_type: "savings", variant: "esign/api" };
            const res = await apiInitiateNach(state.baseUrl, state.token, state.partnerLoanId, body);
            setOut(JSON.stringify(res, null, 2));
        } catch (e) {
            setOut("❌ " + e.message);
        } finally { setLoading(false); }
    };

    return (
        <div style={card}>
            <h2 style={h2}>5) Initiate NACH</h2>
            <select style={inp} value={mode} onChange={(e) => setMode(e.target.value)}>
                <option value="esign">eSign (variant: esign/api)</option>
                <option value="upi">UPI NACH (is_setu: true)</option>
            </select>
            <button style={btn} onClick={run} disabled={loading || !state.token || !state.partnerLoanId}>
                Initiate NACH
            </button>
            <pre style={pre}>{loading ? "⏳ loading..." : out || "No response yet"}</pre>
        </div>
    );
}
const card = { padding: 16, border: "1px solid #334155", borderRadius: 12, background: "#0f172a" };
const h2 = { marginTop: 0 };
const inp = { marginRight: 10, padding: 10, borderRadius: 10, border: "1px solid #334155", background: "#fffff", color: "#e5e7eb", width: 260 };
const btn = { padding: "10px 14px", borderRadius: 10, border: "1px solid #475569", background: "#1f2937", color: "#e5e7eb", cursor: "pointer" };
const pre = { marginTop: 12, background: "#fffff", border: "1px solid #334155", borderRadius: 10, padding: 12, overflow: "auto", maxHeight: 360 };
